import React from 'react';

const OHr = ({ text, visible = false, mt = false }) => {
    return (
        <div className={`hr-container ${mt ? 'mb-0' : ''}`} hidden={visible}>
            <hr className="hr-line" />
            <span className="hr-text">{text}</span>
            <hr className="hr-line" />
        </div>
    );
};

export default OHr;
